import { DayJournal, JournalState, Tag, TagCategory } from './types'
import { uid } from './id'

/** Neutral grey used for every new category and tag until the user picks a colour. */
export const DEFAULT_TAG_COLOR = '#8b9099'

// Palette offered when the user wants to colour a tag manually. Grey first, so
// the default stays neutral everywhere.
export const TAG_COLORS = [
  DEFAULT_TAG_COLOR,
  '#4f46e5',
  '#0ea5e9',
  '#059669',
  '#16a34a',
  '#d97706',
  '#ea580c',
  '#dc2626',
  '#db2777',
  '#7c3aed',
  '#0891b2',
  '#64748b'
]

/** Neutral chip styling shared by selectors, filters, history and dashboard. */
export const NEUTRAL_CHIP = {
  backgroundColor: '#f1f2f4',
  borderColor: '#e2e4e8',
  color: '#555b66'
}

// Seed categories act only as headers: no tag repeats its category name.
// Every account receives its own editable copy.
function seedTags(): { categories: TagCategory[]; tags: Tag[] } {
  const direccion = uid('cat')
  const zona = uid('cat')
  const entrada = uid('cat')

  const categories: TagCategory[] = [
    { id: direccion, name: 'Dirección', timeframe: 'Diario', multiple: false, order: 0 },
    { id: zona, name: 'Zona', timeframe: 'H1', multiple: false, order: 1 },
    { id: entrada, name: 'Entrada', timeframe: 'M5', multiple: false, order: 2 }
  ]

  const spec: [string, string[]][] = [
    [direccion, ['Vela atrapada', 'Continuación', 'Rango']],
    [zona, ['Liquidez', 'Ineficiencia']],
    [entrada, ['OB M5 + OB M1', 'OB H1 + OB M5', 'OB M5', 'Reentrada INF M5']]
  ]

  const tags: Tag[] = []
  spec.forEach(([categoryId, labels]) => {
    labels.forEach((label, order) => {
      tags.push({ id: uid('tag'), categoryId, label, color: DEFAULT_TAG_COLOR, order })
    })
  })

  return { categories, tags }
}

export function createEmptyJournal(date: string, userId?: string): DayJournal {
  return {
    userId,
    date,
    title: '',
    followedPlan: null,
    reviewStatus: 'none',
    blocks: [],
    updatedAt: Date.now()
  }
}

/** Every new account starts empty, with its own editable copy of the seed tags. */
export function createInitialState(userId: string): JournalState {
  const { categories, tags } = seedTags()
  return {
    userId,
    operations: [],
    categories,
    tags,
    dayJournals: {}
  }
}
